import React from 'react';
import { createFragmentContainer, graphql } from 'react-relay';
import PropTypes from 'prop-types';
import { FormattedMessageWrappedInSpan } from '../../misc';
import { Link } from 'react-router-dom';

import CustomDate from '../../misc/CustomDate';

const EventInfoCard = (props) => {
  const {
    eventInfo,
    bestOfAvailable,
    onExpandBestof,
    eventBannerActAsLink,
    handleScrollToOffer,
    shouldShowAdditionalOffer,
    startnumber,
    displayBestof,
  } = props;

  return (
    <div className="col-xs-16 col-sm-6 col-sm-offset-2">
      <div className="event-info-card-container">
        <div className="event-info-card-banner">
          {eventBannerActAsLink && startnumber && (
            <Link to={`/event/${eventInfo.sgId}/smartsearch/${startnumber}`}>
              <div
                className="absolute-cover"
                style={{ backgroundImage: `url(${eventInfo.banner})` }}
              />
            </Link>
          )}
          {eventBannerActAsLink && !startnumber && (
            <Link to={`/event/${eventInfo.sgId}`}>
              <div
                className="absolute-cover"
                style={{ backgroundImage: `url(${eventInfo.banner})` }}
              />
            </Link>
          )}
          {!eventBannerActAsLink && (
            <div
              className="absolute-cover"
              style={{ backgroundImage: `url(${eventInfo.banner})` }}
            />
          )}
        </div>
        <div className="event-info-card-info">
          {eventBannerActAsLink && startnumber && (
            <Link to={`/event/${eventInfo.sgId}/smartsearch/${startnumber}`}>
              <div className="event-info-card-name">{eventInfo.name}</div>
            </Link>
          )}
          {eventBannerActAsLink && !startnumber && (
            <Link to={`/event/${eventInfo.sgId}`}>
              <div className="event-info-card-name">{eventInfo.name}</div>
            </Link>
          )}
          {!eventBannerActAsLink && (
            <div className="event-info-card-name">{eventInfo.name}</div>
          )}
          <div className="event-info-card-details">
            <p>
              <span>{eventInfo.location}</span>
              <CustomDate value={eventInfo.beginsAt} />
            </p>
            <a target="_blank" href={eventInfo.hostHomepageUrl}>
              {eventInfo.hostHomepageName}
            </a>
          </div>
          {bestOfAvailable && (
            <div
              className={`event-info-card-expand-bestof ${
                displayBestof && 'distinctive'
              }`}
              onClick={onExpandBestof}
            >
              <FormattedMessageWrappedInSpan
                id="eventInfoCard.bestOfLink"
                defaultMessage="Bestof-Gallery"
              />
              <span className="icon eye"></span>
            </div>
          )}
          {shouldShowAdditionalOffer && (
            <div className="event-info-card-extras-info" onClick={handleScrollToOffer}>
              <FormattedMessageWrappedInSpan
                id="eventInfoCard.availableExtras"
                defaultMessage="This event's <b>Foto-Flat</b> contains <span>cool extras</span> "
                values={{
                  span: (chunks) => (
                    <span className="extras-info-highlight">{chunks}</span>
                  ),
                  b: (chunks) => <b className="extras-info-fotoflat">{chunks}</b>,
                }}
              />
              <span className="icon eye" />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

EventInfoCard.propTypes = {
  eventInfo: PropTypes.object,
  bestOfAvailable: PropTypes.bool,
  eventBannerActAsLink: PropTypes.bool,
  onExpandBestof: PropTypes.func,
  handleScrollToOffer: PropTypes.func,
  shouldShowAdditionalOffer: PropTypes.bool,
  startnumber: PropTypes.string,
  displayBestof: PropTypes.bool,
};

export { EventInfoCard };

export default createFragmentContainer(EventInfoCard, {
  eventInfo: graphql`
    fragment EventInfoCard_eventInfo on Event {
      id
      sgId
      beginsAt
      banner
      hostHomepageName
      hostHomepageUrl
      location
      name
      predecessorEvent {
        name
      }
    }
  `,
});
